import { render, staticRenderFns } from "./PsiFormBlankField.vue?vue&type=template&id=af2e5ffe&scoped=true&"
import script from "./PsiFormBlankField.vue?vue&type=script&lang=js&"
export * from "./PsiFormBlankField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2e5ffe",
  null
  
)

export default component.exports